import React, { Suspense } from "react";
import AdminstrationMenu from "../components/Administration/AdminMenu/AdminstartionResponsive";
import SnippetList from "../components/Administration/SnippetManagement/ManageSnippetResponsive";
import ChannelListIndex from "../components/Channel/ChannelResponsive";
import ChannelDetailIndex from "../components/ChannelDetail/ChannelResponsive";
import ChangePersonStatus from "../components/CommanComponents/ChangePersonStatus";
import LoadingPage from "../components/CommanComponents/LoadingPage1";
import EventIndex from "../components/Event/EventResponsive";
import Index from "../components/Group/GroupListResponsive";
import GroupDetailIndex from "../components/GroupDetail/GroupDetailResponsive";
import GroupPersonList from "../components/GroupDetailPersonList/GroupDetailPerosnListResponsive";
import MailIndex from "../components/Mail/MailListResponsive";
import MailDetailIndex from "../components/MailDetails/MailDetailResponsive";
import MailPersonListIndex from "../components/MailDetailsPersonList/MailDetailPersonListResponsive";
import PersonDetailIndex from "../components/PersonDetail/PersonDetailResponsive";
import ChangeUserPassword from "../components/ChangePassword/ChangePasswordResponsive";
import ManageProfile from "../components/ManageProfile/ManageProfileResponsive";
import RegisterUser from "../components/Register/RegisterUserResponsive";
import UpdateProfile from "../components/UpdateProfile/UpdateProfileResponsive";
import UserSubScribe from "../components/Profile/UserSubScribe";
import UserUnSubScribe from "../components/Profile/UserUnSubScribe";
import ReportIndex from "../components/Report/ReportResponsive";
import VerifyUser from "../components/Profile/VerifyUser";
import FacebookConnection from "../components/ChannelDetail/ChannelDetailMobile/FacebookConnection";
import TwitterConnection from "../components/ChannelDetail/ChannelDetailMobile/TwitterConnection";
import UserList from "../components/Administration/UserManagement/ManageUserResponsive";
import SetUpSeystem from "../components/Administration/SetupSystem/SetUpSystemMobile";
import EmailList from "../components/Administration/EmailMangement/ManageEmailResponsive";
import ReportList from "../components/Administration/ManageReportType/ManageReportTypeResponsive";
import GroupList from "../components/Administration/ManageGroupType/ManageGroupTypeResponsive";
import EventListType from "../components/Administration/ManageEventListType/ManageEventTypeResponsive";
import ListType from "../components/Administration/ManageListType/ManageListTypeResponsive";
import MenuList from "../components/Administration/ManageMenu/ManageMenuResponsive";
import LocationList from "../components/Administration/ManageLocation/ManageLocationResponsive";
import PersonDataTypeList from "../components/Administration/ManagePersonDataType/ManageLocationResponsive";
import AdminChannelListIndex from "../components/Administration/ManageChannel/ManageChannelResponsive";
import ChannelType from "../components/Administration/ManageChannelType/ManageChannelTypeResponsive";
import ReportEventList from "../components/Administration/LinkReportAndSnippet/LinkReportAndSnippetResponsive";
import ChangeLanguage from "../components/ChangeLanguage/ChangeLanguageResponsive";
import TwitterAcknowledge from "../components/ChannelDetail/ChannelDetailDesktop/TwitterAcknowledge";
const Login = React.lazy(() => import("../components/GuestUser/LoginModule/LoginResponsive"));
const ForgotPassword = React.lazy(() =>
  import("../components/GuestUser/ForgotPassword/ForgotPasswordResponsive")
);
const ChangePassword = React.lazy(() =>
  import("../components/GuestUser/ChangePassword/ChangePasswordResponsive")
);
const Home = React.lazy(() => import("../components/Home/HomeResponsive"));

export const appRoutes = [
         {
           exact: true,
           path: "/",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <Login />
             </Suspense>
           ),
         },
         {
           exact: true,
           path: "/user/register",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <RegisterUser />
             </Suspense>
           ),
         },
         {
           exact: true,
           path: "/forgot_password",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ForgotPassword />
             </Suspense>
           ),
         },
         {
           path: "/activate",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ChangePersonStatus />
             </Suspense>
           ),
         },
         {
           exact: true,
           path: "/recover_password",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ChangePassword />
             </Suspense>
           ),
         },
         {
           exact: true,
           path: "/profile",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <UpdateProfile />
             </Suspense>
           ),
         },
         {
           exact: true,
           path: "/manage-profile",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <UserSubScribe />
             </Suspense>
           ),
         },
         {
           path: "/verify-user",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <VerifyUser />
             </Suspense>
           ),
         },
         {
           exact: true,
           path: "/unsubscribe",
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <UserUnSubScribe />
             </Suspense>
           ),
         },
       ];

export const privateRoutes = [
         {
           path: "/home",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <Home />
             </Suspense>
           ),
         }
         , {
          path: "/twitter-acknowledge",
          exact: true,
          component: () => (
            <Suspense fallback={<LoadingPage />}>
              <TwitterAcknowledge />
            </Suspense>
          ),
        },
         {
           path: "/event-list",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <EventIndex />
             </Suspense>
           ),
         },
         {
           path: "/group-list",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <Index />
             </Suspense>
           ),
  }, {
           path: "/change-language",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ChangeLanguage/>
      </Suspense>
    ),
  },
         {
           path: "/group-detail/:group_id",
           exact: false,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <GroupDetailIndex key={window.location.pathname}/>
             </Suspense>
           ),
         },
         {
           path: "/group-personlist/:group_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <GroupPersonList />
             </Suspense>
           ),
         },
         {
           path: "/person-detail/:group_person_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <PersonDetailIndex />
             </Suspense>
           ),
         },
         {
           path: "/mail-list",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <MailIndex />
             </Suspense>
           ),
         },
         {
           path: "/event/:event_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ReportIndex />
             </Suspense>
           ),
         },
         {
           path: "/mail-detail/:mail_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <MailDetailIndex  key={window.location.pathname}/>
             </Suspense>
           ),
         },
         {
           path: "/manage-default-snippet",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ReportEventList />
             </Suspense>
           ),
         },
         {
           path: "/event/:event_id/report/:report_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ChannelListIndex />
             </Suspense>
           ),
         },
         {
           path: "/connect-facebook",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <FacebookConnection />
             </Suspense>
           ),
         },
         {
           path: "/connect-twitter",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <TwitterConnection />
             </Suspense>
           ),
         },
         {
           path: "/event/:event_id/report/:report_id/message/:message_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ChannelDetailIndex />
             </Suspense>
           ),
         },
         {
           path: "/mail-details-personlist/:mail_person_id",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <MailPersonListIndex />
             </Suspense>
           ),
         },
        
         {
           path: "/update-profile",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ManageProfile />
             </Suspense>
           ),
         },
         {
           path: "/change-password",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <ChangeUserPassword />
             </Suspense>
           ),
         },
         {
           path: "/administration",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <AdminstrationMenu />
             </Suspense>
           ),
  },
         {
           path: "/manage-user",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <UserList />
             </Suspense>
           ),
         },
         {
           path: "/setup-system",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <SetUpSeystem />
             </Suspense>
           ),
         },
         {
           path: "/manage-snippet",
           exact: true,
           component: () => (
             <Suspense fallback={<LoadingPage />}>
               <SnippetList />
             </Suspense>
           ),
  },
  {
    path: "/manage-emails",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <EmailList />
      </Suspense>
    ),
  },
  {
    path: "/manage-report-type",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ReportList />
      </Suspense>
    ),
  }, {
    path: "/manage-group-type",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <GroupList />
      </Suspense>
    ),
  }, {
    path: "/manage-eventlist-type",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <EventListType />
      </Suspense>
    ),
  }, {
    path: "/manage-list-type",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ListType />
      </Suspense>
    ),
  }, {
    path: "/manage-channel-type",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <ChannelType />
      </Suspense>
    ),
  }, {
    path: "/manage-menu",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <MenuList />
      </Suspense>
    ),
  }, {
    path: "/manage-location",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <LocationList />
      </Suspense>
    ),
  }, {
    path: "/manage-person-datatype",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <PersonDataTypeList />
      </Suspense>
    ),
  }, {
    path: "/channel-list",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <AdminChannelListIndex />
      </Suspense>
    ),
  },  {
    path: "/mail-search",
    exact: true,
    component: () => (
      <Suspense fallback={<LoadingPage />}>
        <Home />
      </Suspense>
    ),
  },
       ];
